import {formatPlural} from '@uwm/localization';

import type {PluralFormsModel} from '@/types/aem';
import {formatString} from '@/utils/stringUtils';

/** Injects a plural-formatted count into notification description's `{0}` placeholder. */
export const formatNotificationWithPlural = <T extends {description?: string}>(
    notification: T | undefined,
    count: number,
    forms: PluralFormsModel | undefined,
    locale: string
): T | undefined => {
    if (!notification?.description) return notification;
    const pluralText = formatPlural(count, forms, locale);
    if (!pluralText) return notification;
    return {...notification, description: formatString(notification.description, pluralText)};
};
